import { MediaModel as MediaApi } from '@/http/models/media/Media'
import type { MediaServiceConfig } from '@iws/media-library'

export const createMediaService = (): MediaServiceConfig => ({
  getRootFolders: async () => {
    const res = await MediaApi.getRootFolders({ query: { page: 1, length: 100 } })
    return res.data.result
  },
  getFolder: async (id) => {
    const res = await MediaApi.getFolder({ id })
    return res.data.result
  },
  uploadFile: async (file, folderId) => {
    const formData = new FormData()
    if (folderId) formData.append('folder_id', folderId)
    formData.append('file', file)
    formData.append('name', file.name)
    const isImage = file.type.startsWith('image/')
    const res = await (isImage
      ? MediaApi.uploadImage({ body: formData })
      : MediaApi.uploadDocument({ body: formData }))
    return res.data.result
  },
  deleteFile: async (id) => {
    await MediaApi.deleteMedia({ id })
  },
  deleteFolder: async (id) => {
    await MediaApi.deleteFolder({ id })
  },
  createFolder: async (name, parentId) => {
    const res = await MediaApi.createFolder({
      body: { name, ...(parentId && { parent_id: parentId }) },
    })
    return res.data.result
  },
})
